import { Directive, Input, ElementRef, Renderer, OnInit, Component, ViewContainerRef, TemplateRef, Optional, Injector } from '@angular/core';
import { LoadDrupalLangService } from '../services/load-drupal-lang.service';
import { DrupalLangClass } from '../classes/drupal-lang-class';

/**
 * A directive for set the src attribute (is element is img and href). Also, adds a cursor pointer
 *
 * @export
 * @class CompetitionLinkDirective
 */
@Component({
  selector: "[appCompetitionLink]",
  template: `<div *ngIf="isImage === false;else image">
    <ng-content></ng-content>

    </div>
    <ng-template #image>
      <ng-container *ngIf="lazyLoad===false && isImage === true">
      <img
      [src]="imageUrl"
      />
      </ng-container>
      <ng-container *ngIf="lazyLoad===true && isImage === true">
      <img
      [lazyLoad]="imageUrl"
      />
      </ng-container>

    </ng-template>
    `
})
export class CompetitionLinkDirective extends DrupalLangClass implements OnInit {
  /**
   * Competition id to set
   *
   * @type {string}
   * @memberof CompetitionLinkDirective
   */
  @Input() competitionId: string;
  /**
   *
   * Image size for competition logo.
   * @type {number}
   * @memberof CompetitionLinkDirective
   */
  @Input() size: number = 125;

  /**
   * An input for say if this is an image.
   *
   * @type {boolean}
   * @memberof CompetitionLinkDirective
   */
  @Input()
  isImage: boolean = false;

  /**
   * An input for disable lazy load of image.
   *
   * @type {boolean}
   * @memberof CompetitionLinkDirective
   */
  @Input()
  lazyLoad: boolean = true;

  /**
   * The image url.
   *
   * @memberof CompetitionLinkDirective
   */
  imageUrl = '';

  constructor(
    private _elRef: ElementRef,
    private _renderer: Renderer,
    private view: ViewContainerRef,
    injector: Injector,
  ) {
    super(injector);

  }



  /**
   *
   * @inheritdoc
   * @memberof CompetitionLinkDirective
   */
  ngOnInit() {
    // tslint:disable-next-line:max-line-length
    this._renderer.setElementAttribute(
      this._elRef.nativeElement,
      "href",
      `//worldarchery.sport${this.drupalLangService ? this.drupalLangService.langPrefix : '/'}competition/${this.competitionId}/`
    );
    this.imageUrl = this.isImage ? `//extranet.worldarchery.sport/CompetitionLogos/?Id=${this.competitionId}&Size=${this.size}` : undefined;
  }
}
